import { Button, ButtonProps } from "@chakra-ui/react";

export default function ApplyFiltersButton({
  children = "Apply Filters",
  ...rest
}: ButtonProps) {
  return (
    <Button type="submit" colorScheme="pinkButton" size="sm" {...rest}>
      {children}
    </Button>
  );
}
